import { useEffect, useState } from 'react';
import { api } from '../../../api/client';

export default function HealthPage() {
  const [records, setRecords] = useState<any[]>([]);
  const [students, setStudents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterStudent, setFilterStudent] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    studentId: '',
    type: 'NOTE',
    description: '',
    medication: '',
    dosage: '',
    administeredBy: '',
  });

  const fetchData = () => {
    const params: Record<string, string> = {};
    if (filterStudent) params.studentId = filterStudent;
    Promise.all([
      api.get('/api/health', { params }),
      api.get('/api/students').catch(() => []),
    ]).then(([rec, stu]) => {
      setRecords(rec as any[]);
      setStudents(Array.isArray(stu) ? stu : []);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchData();
  }, [filterStudent]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/api/health', form);
    setShowForm(false);
    setForm({
      studentId: '',
      type: 'NOTE',
      description: '',
      medication: '',
      dosage: '',
      administeredBy: '',
    });
    fetchData();
  };

  const handleDelete = async (id: string) => {
    if (!confirm('¿Eliminar registro?')) return;
    await api.delete(`/api/health/${id}`);
    fetchData();
  };

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Cargando...</div>;

  return (
    <div style={{ minHeight: '100vh' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 24,
        }}
      >
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1a1c2c' }}>🏥 Salud / Enfermería</h1>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: 'var(--primary-gradient)',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          + Nuevo Registro
        </button>
      </div>

      <div style={{ marginBottom: 16 }}>
        <select
          value={filterStudent}
          onChange={(e) => setFilterStudent(e.target.value)}
          style={{
            padding: 8,
            borderRadius: 8,
            border: '1px solid #ddd',
            background: '#fff',
            minWidth: 200,
          }}
        >
          <option value="">Todos los alumnos</option>
          {students.map((s: any) => (
            <option key={s.id} value={s.id}>
              {s.firstName} {s.paternalLastName}
            </option>
          ))}
        </select>
      </div>

      {showForm && (
        <form
          onSubmit={handleSubmit}
          style={{
            background: '#fff',
            borderRadius: 12,
            padding: 20,
            marginBottom: 24,
            maxWidth: 500,
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
          }}
        >
          <div style={{ marginBottom: 12 }}>
            <select
              value={form.studentId}
              onChange={(e) => setForm({ ...form, studentId: e.target.value })}
              required
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            >
              <option value="">Seleccionar alumno</option>
              {students.map((s: any) => (
                <option key={s.id} value={s.id}>
                  {s.firstName} {s.paternalLastName}
                </option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
              required
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            >
              <option value="MEDICATION">Medicación</option>
              <option value="INCIDENT">Incidente</option>
              <option value="NOTE">Nota General</option>
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <textarea
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              placeholder="Descripción"
              required
              rows={3}
              style={{
                width: '100%',
                padding: 10,
                borderRadius: 8,
                border: '1px solid #ddd',
                resize: 'vertical',
              }}
            />
          </div>
          <div
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}
          >
            <input
              value={form.medication}
              onChange={(e) => setForm({ ...form, medication: e.target.value })}
              placeholder="Medicamento"
              style={{ padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            />
            <input
              value={form.dosage}
              onChange={(e) => setForm({ ...form, dosage: e.target.value })}
              placeholder="Dosis"
              style={{ padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <input
              value={form.administeredBy}
              onChange={(e) => setForm({ ...form, administeredBy: e.target.value })}
              placeholder="Administrado por"
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #ddd' }}
            />
          </div>
          <button
            type="submit"
            style={{
              background: 'var(--primary-color)',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Guardar
          </button>
        </form>
      )}

      <div style={{ display: 'grid', gap: 12 }}>
        {records.map((r: any) => (
          <div
            key={r.id}
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: 16,
              borderLeft: `4px solid ${r.type === 'MEDICATION' ? '#4caf50' : r.type === 'INCIDENT' ? '#ff2d55' : '#2196f3'}`,
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
              <div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                  <span
                    style={{
                      fontSize: 12,
                      padding: '2px 8px',
                      borderRadius: 4,
                      background:
                        r.type === 'MEDICATION'
                          ? '#4caf5033'
                          : r.type === 'INCIDENT'
                            ? '#ff2d5533'
                            : '#2196f333',
                      color:
                        r.type === 'MEDICATION'
                          ? '#4caf50'
                          : r.type === 'INCIDENT'
                            ? '#ff2d55'
                            : '#2196f3',
                    }}
                  >
                    {r.type === 'MEDICATION'
                      ? 'Medicación'
                      : r.type === 'INCIDENT'
                        ? 'Incidente'
                        : 'Nota'}
                  </span>
                  <strong style={{ fontSize: 14 }}>
                    {r.student?.firstName} {r.student?.paternalLastName}
                  </strong>
                </div>
                <p style={{ margin: 0, fontSize: 14, color: '#555' }}>{r.description}</p>
                {r.medication && (
                  <p style={{ margin: '4px 0 0', fontSize: 13, color: '#888' }}>
                    💊 {r.medication} {r.dosage ? `- ${r.dosage}` : ''}
                  </p>
                )}
                {r.administeredBy && (
                  <p style={{ margin: '2px 0 0', fontSize: 12, color: '#888' }}>
                    Por: {r.administeredBy}
                  </p>
                )}
              </div>
              <button
                onClick={() => handleDelete(r.id)}
                style={{
                  background: 'none',
                  border: '1px solid var(--primary-color)',
                  color: 'var(--primary-color)',
                  padding: '4px 12px',
                  borderRadius: 6,
                  cursor: 'pointer',
                  fontSize: 12,
                }}
              >
                Eliminar
              </button>
            </div>
            <div style={{ fontSize: 11, color: '#888', marginTop: 8 }}>
              {new Date(r.date).toLocaleString('es-MX')}
            </div>
          </div>
        ))}
        {records.length === 0 && (
          <p style={{ textAlign: 'center', color: '#888', padding: 40 }}>
            No hay registros de salud
          </p>
        )}
      </div>
    </div>
  );
}
